import { Form, Formik } from "formik";
import React from "react";
import { Card, Col, Input, Row } from "reactstrap";
import * as Yup from "yup";
import SignContext from "../../contextAPI/Context/SignContext";
import { useContext, useEffect, useState } from "react";
import { useFormSubmit } from "../../hooks/useFormSubmit";
import { toast } from "react-toastify";

const Investigation = (props) => {
  const [otherinv, setotherinv] = useState({
    labReports: "",
    xRayReport: "",
    ecgReport: "",
    spirometry: "",
    audiometry: "",
    remarks: "",
  });

  const { setInvestigation, GetSpecificOtherDetail, editOther } =
    useContext(SignContext);

  // Debounce hook for form submissions
  const { handleSubmit: debouncedSubmit } = useFormSubmit(500);

  const handleSubmitData = async (values) => {
    const data = {
      ...props,
      chackupNameId: props.chackupNameId,
      checkupTypeId: props.checkupTypeId,
      ...values
    };

    try {
      const response = await setInvestigation(data);

      if (response && (response.data || response.success)) {
        toast.success("Investigation details saved successfully!");
        if (props.onSuccess && response.data?._id) {
          props.onSuccess(response.data._id);
        }
      }
    } catch (error) {

      const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to save investigation details";
      toast.error(errorMessage);
    }
  };

  const validationSchema = Yup.object().shape({
    labReports: Yup.string(),
    xRayReport: Yup.string(),
    ecgReport: Yup.string(),
    spirometry: Yup.string(),
    audiometry: Yup.string(),
    remarks: Yup.string(),
  });
  const gettingid = async () => {
    if (props.otherinv !== null) {
      const res = await GetSpecificOtherDetail(props.otherinv);

      setotherinv(res.data);
    }
  };
  useEffect(() => {
    gettingid();
  }, [props.otherinv]);
  return (
    <>
      {props.otherinv !== null ? (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                otherinv,
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  const data = {
                    ...props,
                    ...otherinv,
                    chackupNameId: props.chackupNameId,
                    checkupTypeId: props.checkupTypeId,
                  };

                  try {
                    const res = await editOther(props.otherinv, data);
                    if (res && (res.data || res.success)) {
                      toast.success("Investigation details updated successfully!");
                      if (props.onSuccess) {
                        props.onSuccess(props.otherinv);
                      }
                    }
                  } catch (error) {

                    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to update investigation details";
                    toast.error(errorMessage);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Card>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className=" m-1">
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Lab Reports
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="lab reports"
                                  name="labReports"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setotherinv({
                                      ...otherinv,
                                      labReports: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    otherinv
                                      ? otherinv.labReports !== null &&
                                        otherinv.labReports !== ""
                                        ? otherinv.labReports
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                X-Ray Reports
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="X-Ray reports"
                                  name="xRayReport"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setotherinv({
                                      ...otherinv,
                                      xRayReport: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    otherinv
                                      ? otherinv.xRayReport !== null &&
                                        otherinv.xRayReport !== ""
                                        ? otherinv.xRayReport
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="m-1">
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                ECG Reports
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="ECG reports"
                                  name="ecgReport"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setotherinv({
                                      ...otherinv,
                                      ecgReport: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    otherinv
                                      ? otherinv.ecgReport !== null &&
                                        otherinv.ecgReport !== ""
                                        ? otherinv.ecgReport
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Spirometry
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="spirometry"
                                  name="spirometry"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setotherinv({
                                      ...otherinv,
                                      spirometry: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    otherinv
                                      ? otherinv.spirometry !== null &&
                                        otherinv.spirometry !== ""
                                        ? otherinv.spirometry
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="m-1">
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Audiometry
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="autometry"
                                  name="audiometry"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setotherinv({
                                      ...otherinv,
                                      audiometry: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    otherinv
                                      ? otherinv.audiometry !== null &&
                                        otherinv.audiometry !== ""
                                        ? otherinv.audiometry
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Remarks
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="remarks"
                                  name="remarks"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setotherinv({
                                      ...otherinv,
                                      remarks: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    otherinv
                                      ? otherinv.remarks !== null &&
                                        otherinv.remarks !== ""
                                        ? otherinv.remarks
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                      </div>
                    </div>
                    <div className="text-end mb-3 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Updating...
                          </>
                        ) : (
                          'Update'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                labReports: "",
                xRayReport: "",
                ecgReport: "",
                spirometry: "",
                audiometry: "",
                remarks: "",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  try {
                    await handleSubmitData(values);
                  } catch (error) {
                    // Error handled by handleSubmitData
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Card>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className=" m-1">
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Lab Reports
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="lab reports"
                                  name="labReports"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.labReports}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                X-Ray Reports
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="X-Ray reports"
                                  name="xRayReport"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.xRayReport}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="m-1">
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                ECG Reports
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="ECG reports"
                                  name="ecgReport"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.ecgReport}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Spirometry
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="spirometry"
                                  name="spirometry"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.spirometry}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="m-1">
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Autometry
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="autometry"
                                  name="audiometry"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.audiometry}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Remarks
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="remarks"
                                  name="remarks"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.remarks}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="text-end mb-3 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Submitting...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Investigation;
